// AI-generated with Claude Code.
// Single code-point (or short) emoji only: the API caps a member's emoji at 8 UTF-16 units,
// so ZWJ sequences and flags are left out. Each entry is [emoji, space-separated search keywords].
export type EmojiEntry = readonly [emoji: string, keywords: string]

export const EMOJI_GROUPS = [
  {
    id: 'faces',
    label: 'Faces',
    emojis: [
      ['🙂', 'smile happy'], ['😀', 'grin happy smile'], ['😃', 'smile happy big eyes'],
      ['😄', 'smile happy laugh'], ['😁', 'grin beam teeth'], ['😆', 'laugh squint'],
      ['😅', 'sweat nervous laugh'], ['🤣', 'rolling floor laugh lol'], ['😂', 'tears joy laugh lol'],
      ['😊', 'blush smile happy'], ['😇', 'angel halo innocent'], ['🥰', 'love hearts adore'],
      ['😍', 'heart eyes love'], ['🤩', 'star struck excited'], ['😘', 'kiss love'],
      ['😋', 'yum tasty delicious'], ['😛', 'tongue silly'], ['😜', 'wink tongue silly'],
      ['🤪', 'zany crazy silly goofy'], ['😝', 'tongue squint silly'], ['🤑', 'money rich dollar'],
      ['🤗', 'hug hugging'], ['🤭', 'giggle oops hand'], ['🤫', 'shush quiet secret'],
      ['🤔', 'thinking hmm'], ['🫡', 'salute respect'], ['🤐', 'zipper mouth secret quiet'],
      ['🤨', 'raised eyebrow suspicious'], ['😐', 'neutral meh'], ['😏', 'smirk sly'],
      ['😌', 'relieved calm peaceful'], ['😴', 'sleeping tired zzz'], ['🤓', 'nerd geek glasses smart'],
      ['😎', 'cool sunglasses'], ['🥸', 'disguise glasses mustache'], ['🤠', 'cowboy hat'],
      ['🥳', 'party celebrate birthday'], ['😺', 'cat smile'], ['😸', 'cat grin'],
      ['😻', 'cat heart eyes love'], ['🤖', 'robot bot'], ['👽', 'alien ufo space'],
      ['👻', 'ghost spooky halloween'], ['🤡', 'clown circus'], ['👾', 'space invader game alien'],
      ['🎃', 'pumpkin halloween jack'], ['😈', 'devil horns mischief'], ['💩', 'poop poo'],
    ],
  },
  {
    id: 'people',
    label: 'People',
    emojis: [
      ['👶', 'baby'], ['🧒', 'child kid'], ['👦', 'boy kid'], ['👧', 'girl kid'], ['🧑', 'person adult'],
      ['👱', 'blond person'], ['👨', 'man dad'], ['👩', 'woman mum mom'], ['🧓', 'older person'],
      ['👴', 'old man grandad grandpa'], ['👵', 'old woman grandma granny nan'], ['🧔', 'beard man'],
      ['👸', 'princess'], ['🤴', 'prince'], ['🦸', 'superhero hero'], ['🦹', 'supervillain villain'],
      ['🧙', 'wizard mage magic'], ['🧚', 'fairy magic'], ['🧛', 'vampire dracula'],
      ['🧜', 'mermaid merperson'], ['🧝', 'elf'], ['🧞', 'genie'], ['🧟', 'zombie'], ['🥷', 'ninja'],
      ['👮', 'police officer cop'], ['🕵️', 'detective spy'], ['💂', 'guard soldier'],
      ['👷', 'builder construction worker'], ['🤶', 'mrs claus christmas'], ['🎅', 'santa christmas'],
      ['🧑‍🚀', 'astronaut space'], ['🧑‍🍳', 'cook chef'],
    ],
  },
  {
    id: 'animals',
    label: 'Animals',
    emojis: [
      ['🐶', 'dog puppy face'], ['🐕', 'dog'], ['🐩', 'poodle dog'], ['🐱', 'cat kitten face'],
      ['🐈', 'cat'], ['🐭', 'mouse face'], ['🐹', 'hamster'], ['🐰', 'rabbit bunny face'], ['🦊', 'fox'],
      ['🐻', 'bear'], ['🐼', 'panda'], ['🐨', 'koala'], ['🐯', 'tiger face'], ['🦁', 'lion'],
      ['🐮', 'cow face'], ['🐷', 'pig face'], ['🐸', 'frog'], ['🐵', 'monkey face'],
      ['🙈', 'see no evil monkey'], ['🐔', 'chicken'], ['🐧', 'penguin'], ['🐦', 'bird'],
      ['🐤', 'chick baby bird'], ['🦆', 'duck'], ['🦅', 'eagle'], ['🦉', 'owl'], ['🦇', 'bat'],
      ['🐺', 'wolf'], ['🐗', 'boar'], ['🐴', 'horse face'], ['🦄', 'unicorn'], ['🐝', 'bee honeybee'],
      ['🐛', 'bug caterpillar'], ['🦋', 'butterfly'], ['🐌', 'snail'], ['🐞', 'ladybird ladybug'],
      ['🐜', 'ant'], ['🕷️', 'spider'], ['🐢', 'turtle tortoise'], ['🐍', 'snake'], ['🦎', 'lizard'],
      ['🦖', 't-rex dinosaur trex'], ['🦕', 'dinosaur sauropod'], ['🐙', 'octopus'], ['🦑', 'squid'],
      ['🦐', 'shrimp prawn'], ['🦀', 'crab'], ['🐡', 'blowfish pufferfish'], ['🐠', 'tropical fish'],
      ['🐟', 'fish'], ['🐬', 'dolphin'], ['🐳', 'whale'], ['🦈', 'shark'], ['🐊', 'crocodile alligator'],
      ['🦓', 'zebra'], ['🦍', 'gorilla'], ['🦧', 'orangutan'], ['🐘', 'elephant'],
      ['🦛', 'hippo hippopotamus'], ['🦏', 'rhino rhinoceros'], ['🐪', 'camel'], ['🦒', 'giraffe'],
      ['🦘', 'kangaroo'], ['🦬', 'bison buffalo'], ['🐿️', 'squirrel chipmunk'], ['🦔', 'hedgehog'],
      ['🦦', 'otter'], ['🦥', 'sloth'], ['🦨', 'skunk'], ['🦡', 'badger'], ['🦩', 'flamingo'],
      ['🦚', 'peacock'], ['🦜', 'parrot'], ['🦢', 'swan'], ['🐓', 'rooster'], ['🦃', 'turkey'],
      ['🐇', 'rabbit bunny'], ['🐁', 'mouse'], ['🦫', 'beaver'], ['🐉', 'dragon'],
    ],
  },
  {
    id: 'nature',
    label: 'Nature',
    emojis: [
      ['🌻', 'sunflower flower'], ['🌹', 'rose flower'], ['🌷', 'tulip flower'],
      ['🌸', 'cherry blossom flower'], ['🌺', 'hibiscus flower'], ['🌼', 'blossom daisy flower'],
      ['💐', 'bouquet flowers'], ['🪷', 'lotus flower'], ['🌱', 'seedling sprout plant'],
      ['🌿', 'herb leaf plant'], ['☘️', 'shamrock clover'], ['🍀', 'four leaf clover lucky'],
      ['🍁', 'maple leaf autumn fall'], ['🍂', 'fallen leaves autumn fall'], ['🍄', 'mushroom'],
      ['🌵', 'cactus desert'], ['🌴', 'palm tree'], ['🌲', 'evergreen pine tree'], ['🌳', 'tree'],
      ['🪴', 'potted plant'], ['🌾', 'wheat rice'], ['🪨', 'rock stone'], ['🐚', 'shell beach'],
      ['🌍', 'earth globe world'], ['🌙', 'moon crescent night'], ['🌛', 'moon face night'],
      ['⭐', 'star'], ['🌟', 'glowing star'], ['✨', 'sparkles magic'], ['☀️', 'sun sunny'],
      ['🌈', 'rainbow'], ['☁️', 'cloud'], ['⛄', 'snowman winter'], ['❄️', 'snowflake snow winter'],
      ['🔥', 'fire flame hot'], ['💧', 'water drop'], ['🌊', 'wave ocean sea surf'],
      ['⚡', 'lightning bolt zap electric'], ['🌪️', 'tornado'], ['🌋', 'volcano'],
    ],
  },
  {
    id: 'food',
    label: 'Food',
    emojis: [
      ['🍎', 'apple fruit'], ['🍐', 'pear fruit'], ['🍊', 'orange tangerine fruit'],
      ['🍋', 'lemon fruit'], ['🍌', 'banana fruit'], ['🍉', 'watermelon fruit'], ['🍇', 'grapes fruit'],
      ['🍓', 'strawberry fruit'], ['🫐', 'blueberries fruit'], ['🍒', 'cherries fruit'],
      ['🍑', 'peach fruit'], ['🥭', 'mango fruit'], ['🍍', 'pineapple fruit'], ['🥥', 'coconut'],
      ['🥝', 'kiwi fruit'], ['🥑', 'avocado'], ['🥕', 'carrot vegetable'], ['🌽', 'corn sweetcorn'],
      ['🥦', 'broccoli vegetable'], ['🍆', 'aubergine eggplant'], ['🌶️', 'chilli pepper hot spicy'],
      ['🥨', 'pretzel'], ['🥐', 'croissant'], ['🥯', 'bagel'], ['🧀', 'cheese'],
      ['🥞', 'pancakes breakfast'], ['🧇', 'waffle breakfast'], ['🥓', 'bacon breakfast'],
      ['🍔', 'burger hamburger'], ['🍟', 'fries chips'], ['🍕', 'pizza'], ['🌭', 'hot dog sausage'],
      ['🌮', 'taco'], ['🌯', 'burrito wrap'], ['🍣', 'sushi'], ['🍜', 'noodles ramen'],
      ['🍝', 'spaghetti pasta'], ['🥟', 'dumpling'], ['🍦', 'ice cream'], ['🍩', 'donut doughnut'],
      ['🍪', 'cookie biscuit'], ['🎂', 'birthday cake'], ['🧁', 'cupcake'], ['🍰', 'cake slice'],
      ['🍫', 'chocolate'], ['🍬', 'sweet candy'], ['🍭', 'lollipop sweet candy'], ['🍿', 'popcorn movie'],
      ['🥤', 'cup drink soda'], ['🧃', 'juice box drink'], ['🧋', 'bubble tea boba'],
      ['🍵', 'tea green'], ['☕', 'coffee hot drink'], ['🥛', 'milk'],
    ],
  },
  {
    id: 'activities',
    label: 'Activities',
    emojis: [
      ['⚽️', 'football soccer ball'], ['🏀', 'basketball ball'], ['🏈', 'american football ball'],
      ['⚾', 'baseball ball'], ['🥎', 'softball ball'], ['🎾', 'tennis ball'],
      ['🏐', 'volleyball ball'], ['🏉', 'rugby ball'], ['🥏', 'frisbee flying disc'],
      ['🎱', 'pool billiards 8 ball'], ['🏓', 'ping pong table tennis'], ['🏸', 'badminton'],
      ['🏒', 'ice hockey'], ['🏑', 'field hockey'], ['🥍', 'lacrosse'], ['🏏', 'cricket'],
      ['⛳', 'golf'], ['🏹', 'bow arrow archery'], ['🎣', 'fishing'], ['🥊', 'boxing glove'],
      ['🥋', 'martial arts karate judo'], ['🛹', 'skateboard'], ['🛼', 'roller skate'],
      ['⛸️', 'ice skate skating'], ['🎿', 'ski skiing'], ['🏂', 'snowboard'], ['🏄', 'surfing surf'],
      ['🏊', 'swimming swim'], ['🚴', 'cycling bike'], ['🧗', 'climbing climb'],
      ['🤸', 'cartwheel gymnastics'], ['🏆', 'trophy winner'], ['🥇', 'gold medal first winner'],
      ['🎯', 'target bullseye darts'], ['🎳', 'bowling'], ['🎮', 'video game controller gaming'],
      ['🕹️', 'joystick arcade game'], ['🎲', 'dice game'], ['🧩', 'puzzle jigsaw'], ['♟️', 'chess pawn'],
      ['🎨', 'art palette paint'], ['🎭', 'theatre drama masks'], ['🎬', 'film movie clapper'],
      ['🎤', 'microphone sing karaoke'], ['🎧', 'headphones music'], ['🎸', 'guitar music rock'],
      ['🎹', 'piano keyboard music'], ['🥁', 'drum music'], ['🎷', 'saxophone sax music'],
      ['🎺', 'trumpet music'], ['🎻', 'violin music'], ['🪕', 'banjo music'], ['🪁', 'kite'],
      ['🎪', 'circus tent'],
    ],
  },
  {
    id: 'travel',
    label: 'Travel',
    emojis: [
      ['🚀', 'rocket space'], ['🛸', 'ufo flying saucer'], ['✈️', 'airplane plane'],
      ['🚁', 'helicopter'], ['⛵', 'sailboat boat'], ['🚤', 'speedboat boat'], ['🚢', 'ship boat'],
      ['🚂', 'train steam locomotive'], ['🚃', 'train carriage'], ['🚌', 'bus'], ['🚎', 'trolleybus bus'],
      ['🏎️', 'racing car'], ['🚓', 'police car'], ['🚑', 'ambulance'], ['🚒', 'fire engine truck'],
      ['🚕', 'taxi cab'], ['🚗', 'car'], ['🚙', 'suv car'], ['🛻', 'pickup truck'],
      ['🚚', 'lorry truck delivery'], ['🚜', 'tractor farm'], ['🏍️', 'motorbike motorcycle'],
      ['🛵', 'scooter moped'], ['🚲', 'bicycle bike'], ['🛴', 'kick scooter'],
      ['🚦', 'traffic light'], ['⚓', 'anchor'], ['🗺️', 'map world'], ['🧭', 'compass'],
      ['🏔️', 'snowy mountain'], ['⛰️', 'mountain'], ['🏕️', 'camping'], ['🏖️', 'beach umbrella'],
      ['🏝️', 'island desert'], ['🏜️', 'desert'], ['🏰', 'castle'], ['🏯', 'japanese castle'],
      ['🗼', 'tower tokyo'], ['🗽', 'statue of liberty'], ['🎡', 'ferris wheel'],
      ['🎢', 'roller coaster'], ['🎠', 'carousel horse'], ['⛺', 'tent camping'], ['🏠', 'house home'],
      ['🌃', 'night city stars'], ['🌅', 'sunrise'], ['🌌', 'milky way galaxy space'],
      ['🎆', 'fireworks'],
    ],
  },
  {
    id: 'objects',
    label: 'Objects',
    emojis: [
      ['👑', 'crown king queen'], ['🎩', 'top hat'], ['🧢', 'cap hat'], ['👓', 'glasses'],
      ['🕶️', 'sunglasses'], ['🎒', 'backpack school bag'], ['👟', 'trainer sneaker shoe'],
      ['🩰', 'ballet shoes dance'], ['💎', 'gem diamond jewel'], ['💍', 'ring diamond'],
      ['🔮', 'crystal ball magic'], ['🪄', 'magic wand'], ['🧸', 'teddy bear toy'], ['🪀', 'yo-yo toy'],
      ['🎈', 'balloon party'], ['🎁', 'gift present'], ['🎀', 'ribbon bow'], ['🪅', 'piñata pinata party'],
      ['🎉', 'party popper celebrate'], ['📚', 'books reading'], ['📖', 'book reading'],
      ['✏️', 'pencil'], ['🖍️', 'crayon'], ['🖌️', 'paintbrush art'], ['📷', 'camera photo'],
      ['🔭', 'telescope space'], ['🔬', 'microscope science'], ['💡', 'light bulb idea'],
      ['🔦', 'torch flashlight'], ['🧲', 'magnet'], ['🧪', 'test tube science'],
      ['⚗️', 'alembic chemistry science'], ['🛠️', 'tools hammer spanner'], ['🔧', 'spanner wrench tool'],
      ['🔑', 'key'], ['🗝️', 'old key'], ['⏰', 'alarm clock'], ['⌛', 'hourglass time'],
      ['📱', 'phone mobile'], ['💻', 'laptop computer'], ['⌨️', 'keyboard computer'],
      ['🖥️', 'desktop computer'], ['📺', 'tv television'], ['📻', 'radio'],
      ['🎙️', 'studio microphone podcast'], ['🔔', 'bell'], ['🪐', 'planet saturn space'],
      ['⚔️', 'swords crossed'], ['🛡️', 'shield'], ['🏺', 'amphora vase'], ['🧿', 'nazar evil eye'],
      ['🪩', 'disco ball mirror ball'],
    ],
  },
  {
    id: 'symbols',
    label: 'Symbols',
    emojis: [
      ['❤️', 'red heart love'], ['🧡', 'orange heart love'], ['💛', 'yellow heart love'],
      ['💚', 'green heart love'], ['💙', 'blue heart love'], ['💜', 'purple heart love'],
      ['🤎', 'brown heart love'], ['🖤', 'black heart love'], ['🤍', 'white heart love'],
      ['💖', 'sparkling heart love'], ['💗', 'growing heart love'], ['💝', 'heart ribbon gift love'],
      ['💯', 'hundred 100 perfect'], ['💥', 'boom collision'], ['💫', 'dizzy star'],
      ['💤', 'zzz sleep'], ['☮️', 'peace'], ['☯️', 'yin yang'], ['♈', 'aries zodiac'],
      ['♉', 'taurus zodiac'], ['♊', 'gemini zodiac'], ['♋', 'cancer zodiac'], ['♌', 'leo zodiac'],
      ['♍', 'virgo zodiac'], ['♎', 'libra zodiac'], ['♏', 'scorpio zodiac'],
      ['♐', 'sagittarius zodiac'], ['♑', 'capricorn zodiac'], ['♒', 'aquarius zodiac'],
      ['♓', 'pisces zodiac'], ['⚛️', 'atom science'], ['♾️', 'infinity'], ['🔴', 'red circle'],
      ['🟠', 'orange circle'], ['🟡', 'yellow circle'], ['🟢', 'green circle'], ['🔵', 'blue circle'],
      ['🟣', 'purple circle'], ['🟤', 'brown circle'], ['⚫', 'black circle'], ['⚪', 'white circle'],
      ['🔶', 'orange diamond'], ['🔷', 'blue diamond'], ['🔺', 'red triangle'],
      ['💠', 'diamond flower'], ['🎵', 'music note'], ['🎶', 'music notes'],
      ['❓', 'question mark'],
    ],
  },
] as const satisfies readonly { id: string; label: string; emojis: readonly EmojiEntry[] }[]

export type EmojiGroupId = (typeof EMOJI_GROUPS)[number]['id']

const ALL_ENTRIES: readonly EmojiEntry[] = EMOJI_GROUPS.flatMap<EmojiEntry>((group) => group.emojis)

export const ALL_EMOJIS: readonly string[] = ALL_ENTRIES.map(([emoji]) => emoji)

// The tab to open on: whichever group already holds the current pick.
export function groupForEmoji(emoji: string): EmojiGroupId {
  return EMOJI_GROUPS.find((group) => group.emojis.some(([candidate]) => candidate === emoji))?.id ?? 'faces'
}

// Every query word must start one of the emoji's keywords, so "ca" finds cat and car.
export function searchEmojis(query: string): string[] {
  const terms = query.toLowerCase().split(/\s+/).filter(Boolean)
  if (terms.length === 0) return []
  return ALL_ENTRIES.filter(([, keywords]) => {
    const words = keywords.split(' ')
    return terms.every((term) => words.some((word) => word.startsWith(term)))
  }).map(([emoji]) => emoji)
}
